import React, {useState} from 'react';
import PropTypes from 'prop-types';
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Menu from "@material-ui/core/Menu";
import Fade from "@material-ui/core/Fade";

/**
 * Simple menu wrapper that handles displaying a possible list of menu items/actions to the user.
 *
 * @param render - functions that takes the close function as argument. This way parent can handle closing the menu.
 */
function MenuActions({render}) {
    const [anchorRef, setAnchorRef] = useState(undefined);
    const [menuOpen, setMenuOpen] = useState(false);

    const onMoreIconClick = (e) => {
        setAnchorRef(e.currentTarget);
        setMenuOpen(true);
    };

    const closeMenu = () => {
        setMenuOpen(false);
        setAnchorRef(null);
    };

    return (
        <div>
            <IconButton ref={anchorRef} onClick={onMoreIconClick}>
                <Icon fontSize="small">more_horiz</Icon>
            </IconButton>
            <Menu
                anchorEl={anchorRef}
                keepMounted
                open={menuOpen}
                onClose={closeMenu}
                disableAutoFocusItem={true}
                autoFocus={false}
                TransitionComponent={Fade}
            >
                {
                    render(closeMenu)
                }
            </Menu>
        </div>
    );
}

MenuActions.propTypes = {
    render: PropTypes.func.isRequired
};
MenuActions.defaultProps = {};

export default MenuActions;
